'use client';
import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const PHONE = '9492935721';
const PHONE_DISPLAY = '(949) 293-5721';
const SMS_LINK = `sms:${PHONE}`;
const CALL_LINK = `tel:+1${PHONE}`;

interface GalleryImage {
  src: string;
  alt: string;
  category: string;
  label?: string;
}

const galleryImages: GalleryImage[] = [
  {
    src: 'https://da1mambadetailing.com/assets/64745EE9-DA2F-493A-B030-5BB30C3F9EA9_1751754690948.jpg',
    alt: 'Pristine Lamborghini after professional detailing service by DA1MAMBA',
    category: 'Exotic',
    label: 'Lamborghini Detail',
  },
  {
    src: 'https://da1mambadetailing.com/assets/IMG_0296_1751754717613.jpg',
    alt: 'BMW M5 and Rolls-Royce fleet service by DA1MAMBA Professional Detailing',
    category: 'Fleet',
    label: 'BMW M5 & Rolls-Royce Fleet',
  },
  {
    src: 'https://da1mambadetailing.com/assets/314609221_166020389450136_2725712082903081790_n_1751758475934.jpg',
    alt: 'Professional Rolls Royce luxury detailing service by DA1MAMBA',
    category: 'Luxury',
    label: 'Rolls-Royce Detail',
  },
  {
    src: 'https://da1mambadetailing.com/assets/314720331_999311210996670_6450261760225461923_n_1751758482735.jpg',
    alt: 'Premium Rolls Royce detailing operations by DA1MAMBA',
    category: 'Luxury',
    label: 'Rolls-Royce Service',
  },
  {
    src: 'https://da1mambadetailing.com/assets/image0_1751736526771.jpeg',
    alt: 'Luxury Rolls-Royce dashboard detailing by DA1MAMBA Professional Detailing',
    category: 'Interior',
    label: 'Rolls-Royce Interior',
  },
  {
    src: 'https://da1mambadetailing.com/assets/97126918-EC29-40BB-B6B4-2F58B077FB33_1751754684931.jpg',
    alt: 'Tesla premium foam wash treatment at golden hour by DA1MAMBA',
    category: 'Exterior',
    label: 'Tesla Foam Wash',
  },
  {
    src: 'https://da1mambadetailing.com/assets/280047261_531716588413514_7693021305676078627_n_1751758254505.jpg',
    alt: 'Lamborghini with paint protection masking before paint correction by DA1MAMBA',
    category: 'Paint Correction',
    label: 'Lamborghini — Before',
  },
  {
    src: 'https://da1mambadetailing.com/assets/280216952_1462596080837580_1062062813163839722_n_1751758262081.jpg',
    alt: 'Lamborghini with flawless paint correction results by DA1MAMBA',
    category: 'Paint Correction',
    label: 'Lamborghini — After',
  },
  {
    src: 'https://da1mambadetailing.com/assets/283101701_1071752860080780_8262492719354045677_n_1751758337801.jpg',
    alt: 'BMW before professional detailing treatment by DA1MAMBA',
    category: 'Exterior',
    label: 'BMW — Before',
  },
  {
    src: 'https://da1mambadetailing.com/assets/283095294_153481787181047_5566779949128775910_n_1751758344596.jpg',
    alt: 'BMW transformation after professional detailing by DA1MAMBA',
    category: 'Exterior',
    label: 'BMW — After',
  },
  {
    src: 'https://da1mambadetailing.com/assets/222567658_340732361105314_2808448692422444200_n_1751757842604.jpg',
    alt: 'Heavily stained interior before DA1MAMBA deep cleaning treatment',
    category: 'Interior',
    label: 'Interior — Before',
  },
  {
    src: 'https://da1mambadetailing.com/assets/224636514_559417168420867_2354790812883650572_n_1751757849520.jpg',
    alt: 'Immaculate interior after DA1MAMBA deep cleaning service',
    category: 'Interior',
    label: 'Interior — After',
  },
  {
    src: 'https://da1mambadetailing.com/assets/259433497_247211697475798_8124183249125052953_n_1751757281389.jpg',
    alt: 'Heavily corroded wheel before restoration by DA1MAMBA',
    category: 'Exterior',
    label: 'Wheel — Before',
  },
  {
    src: 'https://da1mambadetailing.com/assets/259226882_321074162852339_2413736059867525475_n_1751757275975.jpg',
    alt: 'Restored wheel with perfect finish by DA1MAMBA',
    category: 'Exterior',
    label: 'Wheel — After',
  },
  {
    src: 'https://da1mambadetailing.com/assets/272985376_361434715437341_1899766350536614438_n_1751758154206.jpg',
    alt: 'Muddy off-road Jeep before professional cleaning by DA1MAMBA',
    category: 'Exterior',
    label: 'Jeep — Before',
  },
  {
    src: 'https://da1mambadetailing.com/assets/273007642_624158838653013_875377699664385637_n_1751758161383.jpg',
    alt: 'Clean Jeep with professional lighting effects after DA1MAMBA detailing',
    category: 'Exterior',
    label: 'Jeep — After',
  },
  {
    src: 'https://da1mambadetailing.com/assets/image_1751755535629.jpg',
    alt: 'Professional hand detailing of engine components by DA1MAMBA',
    category: 'Engine',
    label: 'Engine Bay Detail',
  },
  {
    src: 'https://da1mambadetailing.com/assets/bentley_interior_1.jpg',
    alt: 'Bentley luxury interior detailing and restoration by DA1MAMBA',
    category: 'Interior',
    label: 'Bentley Interior',
  },
];

const categories = ['All', 'Exotic', 'Luxury', 'Interior', 'Exterior', 'Paint Correction', 'Fleet', 'Engine'];

export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState<GalleryImage | null>(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const filtered = activeCategory === 'All'
    ? galleryImages
    : galleryImages.filter((img) => img.category === activeCategory);

  const openLightbox = (img: GalleryImage, index: number) => {
    setLightbox(img);
    setLightboxIndex(index);
  };

  const prevImage = () => {
    const newIndex = (lightboxIndex - 1 + filtered.length) % filtered.length;
    setLightbox(filtered[newIndex]);
    setLightboxIndex(newIndex);
  };

  const nextImage = () => {
    const newIndex = (lightboxIndex + 1) % filtered.length;
    setLightbox(filtered[newIndex]);
    setLightboxIndex(newIndex);
  };

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!lightbox) return;
      if (e.key === 'Escape') setLightbox(null);
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'ArrowRight') nextImage();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightbox, lightboxIndex, filtered]);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal:not(.visible)').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 80);
            });
          }
        });
      },
      { threshold: 0.06 }
    );
    document.querySelectorAll('section')?.forEach((s) => obs?.observe(s));
    return () => obs?.disconnect();
  }, []);

  return (
    <div style={{ background: 'var(--mamba-black)', minHeight: '100vh' }}>
      <Header />
      <main>
        {/* Hero */}
        <section
          style={{
            paddingTop: '0',
            paddingBottom: '0',
            position: 'relative',
            overflow: 'hidden',
            minHeight: '55vh',
            display: 'flex',
            alignItems: 'flex-end',
          }}
        >
          {/* Background image */}
          <div className="absolute inset-0">
            <Image
              src="https://da1mambadetailing.com/assets/64745EE9-DA2F-493A-B030-5BB30C3F9EA9_1751754690948.jpg"
              alt="Pristine Lamborghini after professional detailing service by DA1MAMBA"
              fill
              className="object-cover object-center"
              priority
              quality={90}
            />
          </div>
          <div
            className="absolute inset-0"
            style={{ background: 'linear-gradient(100deg, rgba(5,5,5,0.97) 0%, rgba(5,5,5,0.75) 55%, rgba(5,5,5,0.3) 100%)' }}
          />
          <div
            className="absolute bottom-0 inset-x-0"
            style={{ height: '50%', background: 'linear-gradient(to top, rgba(10,10,10,1) 0%, transparent 100%)' }}
          />
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ background: 'radial-gradient(ellipse 50% 80% at 20% 50%, rgba(107,33,168,0.12) 0%, transparent 70%)' }}
          />
          <div className="max-w-7xl mx-auto px-6 relative z-10 pb-20 pt-40 w-full">
            <div className="label-gold mb-5 reveal">
              <span style={{ width: '40px', height: '1px', background: 'var(--mamba-gold-light)', display: 'inline-block' }} />
              Professional Gallery
            </div>
            <h1
              className="reveal reveal-delay-1"
              style={{
                fontFamily: 'Manrope, sans-serif',
                fontWeight: 900,
                fontSize: 'clamp(44px, 7vw, 88px)',
                lineHeight: '0.95',
                letterSpacing: '-0.03em',
                color: 'var(--white)',
                marginBottom: '20px',
              }}
            >
              Witness the<br />
              <span
                style={{
                  background: 'linear-gradient(135deg, var(--mamba-purple-bright), #9333ea 50%, var(--mamba-gold-light))',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                transformation.
              </span>
            </h1>
            <p className="reveal reveal-delay-2" style={{ color: 'rgba(209,213,219,0.8)', fontSize: '18px', lineHeight: '1.65', fontFamily: 'DM Sans, sans-serif', maxWidth: '520px', marginBottom: '32px' }}>
              Luxury vehicles through our meticulous attention to detail — real results from real clients across Newport Beach, Irvine, and Orange County.
            </p>
            <div className="flex gap-3 reveal reveal-delay-3">
              <a href={SMS_LINK} className="btn-primary" style={{ fontSize: '13px', padding: '16px 32px' }}>
                Text for a Quote
              </a>
              <a href={CALL_LINK} className="btn-gold" style={{ fontSize: '13px', padding: '15px 28px' }}>
                Call {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </section>

        {/* Gallery */}
        <section style={{ padding: '80px 0 120px' }}>
          <div className="max-w-7xl mx-auto px-6">
            {/* Filter tabs */}
            <div className="flex flex-wrap gap-2 mb-12 reveal">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  style={{
                    fontFamily: 'Manrope, sans-serif',
                    fontWeight: 600,
                    fontSize: '12px',
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    padding: '8px 18px',
                    borderRadius: '2px',
                    border: activeCategory === cat
                      ? '1px solid var(--mamba-purple-bright)'
                      : '1px solid var(--gray-faint)',
                    background: activeCategory === cat
                      ? 'rgba(107,33,168,0.2)'
                      : 'transparent',
                    color: activeCategory === cat
                      ? 'var(--white)'
                      : 'var(--gray-dim)',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* Masonry-style grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {filtered.map((img, i) => (
                <div
                  key={img.src}
                  className="gallery-item reveal"
                  style={{
                    transitionDelay: `${(i % 6) * 0.06}s`,
                    aspectRatio: '4/3',
                    borderRadius: '2px',
                    position: 'relative',
                    cursor: 'pointer',
                  }}
                  onClick={() => openLightbox(img, i)}
                >
                  <Image
                    src={img.src}
                    alt={img.alt}
                    fill
                    className="object-cover"
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  />
                  <div className="gallery-overlay" />
                  {/* Label */}
                  <div
                    className="absolute bottom-0 inset-x-0 p-4 z-10"
                    style={{
                      background: 'linear-gradient(to top, rgba(10,10,10,0.9) 0%, transparent 100%)',
                      opacity: 0,
                      transition: 'opacity 0.3s ease',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.opacity = '1'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.opacity = '0'; }}
                  >
                    <div style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '13px', color: 'var(--white)' }}>
                      {img.label}
                    </div>
                    <div style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '11px', color: 'var(--mamba-gold-light)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                      {img.category}
                    </div>
                  </div>
                  {/* Expand icon */}
                  <div
                    className="absolute top-3 right-3 z-10"
                    style={{
                      background: 'rgba(107,33,168,0.5)',
                      padding: '6px',
                      borderRadius: '2px',
                      opacity: 0,
                      transition: 'opacity 0.3s ease',
                    }}
                  >
                    <svg width="14" height="14" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom CTA */}
        <section
          style={{
            padding: '80px 0',
            background: 'var(--mamba-graphite)',
            borderTop: '1px solid rgba(107,33,168,0.2)',
          }}
        >
          <div className="max-w-3xl mx-auto px-6 text-center">
            <h2
              className="section-heading reveal"
              style={{ fontSize: 'clamp(28px, 4vw, 44px)', marginBottom: '16px' }}
            >
              Ready for your<br />
              <span className="text-gradient-purple">transformation?</span>
            </h2>
            <p className="reveal reveal-delay-1" style={{ color: 'var(--gray-dim)', fontSize: '16px', lineHeight: '1.7', fontFamily: 'DM Sans, sans-serif', marginBottom: '36px' }}>
              Experience the same level of professional detailing for your luxury vehicle.
            </p>
            <div className="flex flex-wrap gap-3 justify-center reveal reveal-delay-2">
              <a href={SMS_LINK} className="btn-primary" style={{ fontSize: '14px', padding: '16px 36px' }}>
                Text for a Quote
              </a>
              <a href={CALL_LINK} className="btn-gold" style={{ fontSize: '14px', padding: '15px 32px' }}>
                Call {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* Lightbox */}
      {lightbox && (
        <div
          className="lightbox-overlay"
          onClick={() => setLightbox(null)}
        >
          {/* Close */}
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-6 z-10"
            style={{ color: 'white', background: 'rgba(107,33,168,0.4)', border: '1px solid rgba(107,33,168,0.6)', padding: '10px', borderRadius: '2px' }}
            aria-label="Close"
          >
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          {/* Prev */}
          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-10"
            style={{ color: 'white', background: 'rgba(107,33,168,0.4)', border: '1px solid rgba(107,33,168,0.6)', padding: '12px', borderRadius: '2px' }}
            aria-label="Previous"
          >
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>

          {/* Next */}
          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-10"
            style={{ color: 'white', background: 'rgba(107,33,168,0.4)', border: '1px solid rgba(107,33,168,0.6)', padding: '12px', borderRadius: '2px' }}
            aria-label="Next"
          >
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>

          {/* Image */}
          <div
            className="relative"
            style={{ maxWidth: '90vw', maxHeight: '80vh', width: '100%', height: '100%' }}
            onClick={(e) => e.stopPropagation()}
          >
            <Image
              src={lightbox.src}
              alt={lightbox.alt}
              fill
              className="object-contain"
              sizes="90vw"
            />
          </div>

          {/* Caption */}
          <div
            className="absolute bottom-6 left-1/2 -translate-x-1/2 text-center"
            style={{ pointerEvents: 'none' }}
          >
            <div style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '14px', color: 'var(--white)' }}>
              {lightbox.label}
            </div>
            <div style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '12px', color: 'var(--mamba-gold-light)', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              {lightbox.category} · {lightboxIndex + 1} / {filtered.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
